/**
 * One shape for every phone number Steward prints or shows: 801-555-0100.
 *
 * The numbers arrive in whatever shape their source uses — LCR sends
 * "(801) 555-0100", a person typing into an assignment field sends whatever
 * they type — and a column of numbers set three ways is harder to read than
 * any one of the three. Normalising on display rather than on the way in
 * keeps the stored value exactly as its source gave it, which matters when
 * the source is the ward roster and the question is later "what does LCR
 * actually say".
 *
 * Anything that is not a plain ten-digit number is returned untouched:
 * "800-RED-CROSS", "801-555-0100 x2 (Tanner's cell)", a partial number
 * somebody is still typing. Those carry information that reformatting would
 * either destroy or, worse, silently drop.
 */
export function formatPhone(v: string | null | undefined): string {
  if (!v) return '';
  const raw = v.trim();
  const digits = raw.replace(/\D/g, '');
  const ten = digits.length === 10 ? digits
    : digits.length === 11 && digits.startsWith('1') ? digits.slice(1)
      : null;
  if (!ten) return raw;
  // Letters mean a mnemonic (800-RED-CROSS), and a trailing word means a note.
  // Either way the string is doing more than being a number, so leave it be.
  if (/[a-z]/i.test(raw)) return raw;
  return `${ten.slice(0, 3)}-${ten.slice(3, 6)}-${ten.slice(6)}`;
}

/** The digits, for a tel: href. */
export const telHref = (v: string) => `tel:${v.replace(/\D/g, '')}`;
